import { render, staticRenderFns } from "./defectiveGoods.vue?vue&type=template&id=b78d0d08&"
import script from "./defectiveGoods.vue?vue&type=script&lang=js&"
export * from "./defectiveGoods.vue?vue&type=script&lang=js&"
import style0 from "./defectiveGoods.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports